import '@/installCompositionApi'

import http from '@/helpers/http'
import { mount } from '@/mounter'

import AhvMailing from './AhvMailing'

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})

mount('ahv-mailing', AhvMailing)
